import { Flex, Heading, Link, Text } from '@chakra-ui/react';
import { ErrorBoundary } from 'react-error-boundary';

import Header from './Header';

export default function Layout({ children }) {
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
      <Flex direction='column' h='100%' sx={{ '--header-height': '56px' }}>
        <Flex
          align='center'
          bg='blue.400'
          flexShrink='0'
          height='var(--header-height)'
          justify='space-between'
          p='2'
        >
          <Header />
        </Flex>
        {children}
      </Flex>
    </ErrorBoundary>
  );
}

function ErrorBoundaryFallback({ error: _error }) {
  return (
    <Flex align='center' direction='column' pt='12'>
      <Heading>Mhmm, something didn&apos;t go as expected</Heading>
      <Text as='p' fontSize='lg'>
        Try refreshing the page or{' '}
        <Link isExternal href='https://support.invgate.com/incident/create'>
          create a ticket
        </Link>{' '}
        if the error persists
      </Text>
    </Flex>
  );
}
